

































































































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class StudyFirestoreComponent extends Vue {
  @Prop()
  private msg!: string;

  //name: 'StudyFirestoreOverviewComponent',
  //props: {
  //  msg: String
  //},
  
  created () {
    //this.albums = [this.album_1, this.album_2, this.album_3, this.album_4, this.album_5, this.album_6, this.album_7]
    //this.firstVideo()
  }
  
}
